module.exports = __webpack_public_path__ + "img/ai-fuzhu2.2b33603d.png";